@if (!isLoading) {
  <microsec-card [isBordered]="true">
    <div class="flex flex-col gap-4 w-full">
      <div class="font-bold text-xl">Manage Users</div>
      <div class="text-gray-500">Through the Admin Console, you can</div>
      <div class="text-gray-500">
        <ul class="flex flex-col my-0 gap-2">
          <li>Create or delete users</li>
          <li>Add a user as organization or project group member</li>
          <li>Edit a user's personal details</li>
          <li>Reset passwords and other credentials</li>
          <li>Map a user's roles and permissions</li>
        </ul>
      </div>
      <p-divider styleClass="my-1" />
      <p-button severity="primary" [style]="{ 'text-transform': 'none' }" [rounded]="true" label="Manage in Admin Console" (onClick)="openLink()" />
    </div>
  </microsec-card>
}
